import { buildAddressEditFormSchema } from '../address/update-form.js';
import { VendorAddressType } from './rules.js';
export const vendorAddressEditFormSchema = buildAddressEditFormSchema(VendorAddressType);
//# sourceMappingURL=update-form.js.map